module.exports = __webpack_public_path__ + "static/media/subjects-active.cfb5ee59.svg";